import React, { FC, useCallback, useEffect, useState } from 'react';
import { REGISTERED_APPS } from '../shared/types/Apps';
import { createContext } from '../dissolve/utils';

type ContextType = {
  updateRunningAppName: (val: REGISTERED_APPS) => void;
  runningAppName: REGISTERED_APPS | undefined;
  storefrontAccessToken?: string;
  useDSRecommEngine?: boolean;
};

const [useSharedContext, ContextProvider, ContextConsumer] =
  createContext<ContextType>();

type Props = {
  currentAppName: REGISTERED_APPS;
  storefrontAccessToken?: string;
  useDSRecommEngine?: boolean;
};

const SharedContextProvider: FC<Props> = ({
  children,
  currentAppName,
  storefrontAccessToken,
  useDSRecommEngine,
}) => {
  const [runningAppName, setRunningAppName] = useState<
    REGISTERED_APPS | undefined
  >();

  useEffect(() => {
    updateRunningAppName(currentAppName);
    // eslint-disable-next-line
  }, [currentAppName]);

  const updateRunningAppName = useCallback((val: REGISTERED_APPS) => {
    setRunningAppName(val);
  }, []);

  return (
    <ContextProvider
      value={{
        runningAppName,
        updateRunningAppName,
        storefrontAccessToken,
        useDSRecommEngine,
      }}
    >
      {children}
    </ContextProvider>
  );
};

const SharedContextConsumer = ContextConsumer as React.Consumer<ContextType>;

export { useSharedContext, SharedContextProvider, SharedContextConsumer };
